import { render, staticRenderFns } from "./AutoCompleteMapel.vue?vue&type=template&id=732e0d82&"
import script from "./AutoCompleteMapel.vue?vue&type=script&lang=js&"
export * from "./AutoCompleteMapel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports